module.exports = __webpack_public_path__ + "img/bingo_ball-47.3af999b6.png";